import React, { useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import { attachAuthInterceptor } from './api/client';
import { RequireAuth } from './auth/RequireAuth';
import { Layout } from './components/Layout';
import { PageLoader } from './components/PageLoader';
import { Landing } from './pages/Landing';
import { Dashboard } from './pages/Dashboard';
import { TerminalEditor } from './pages/TerminalEditor';

export default function App() {
  const { getAccessTokenSilently, isLoading } = useAuth0();

  useEffect(() => {
    attachAuthInterceptor(getAccessTokenSilently);
  }, [getAccessTokenSilently]);

  if (isLoading) return <PageLoader label="Loading WATT..." />;

  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/dashboard" element={<RequireAuth component={Dashboard} />} />
        <Route path="/terminals/:id" element={<RequireAuth component={TerminalEditor} />} />
      </Routes>
    </Layout>
  );
}
